import React from 'react';
import FormattedDateTime from '../../../../../components/datetime/FormattedDateTime';

type ShiftDisplayProps = {
  title: string;
  startDate: string;
  endDate: string;
};

export const ShiftDisplay: React.FC<
  React.PropsWithChildren<ShiftDisplayProps>
> = ({ title, startDate, endDate }) => {
  return (
    <>
      {title} (
      <FormattedDateTime dateTime={startDate} format="short" />
      {' - '}
      <FormattedDateTime dateTime={endDate} format="short" />)
    </>
  );
};
